var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-empty"},[_c('TextWithIcon',{attrs:{"text":_vm.defineText,"its-title":"","class-name":"gallery-empty-text"}}),_vm._v(" "),_c('div',{staticClass:"gallery-empty-icon"},[_c('svg-icon',{attrs:{"name":"eye"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }